(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lum-fb-comments"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.__lumCarouselReady) return;
    window.__lumCarouselReady = true;
    function initOne(root){
      var viewport = root.querySelector('[data-lum-viewport]');
      if (!viewport || viewport.dataset.lumInit) return;
      var track = viewport.firstElementChild;
      if (!track) return;
      viewport.dataset.lumInit = '1';
      var speed = parseFloat(root.dataset.scrollSpeed || '0.5');
      var lastTs = performance.now();
      var pauseUntil = 0;
      var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isHovering = false;
      function half(){ return track.scrollWidth / 2; }
      function wrap(){
        var h = half(); if (h <= 0) return;
        if (viewport.scrollLeft >= h) viewport.scrollLeft -= h;
        else if (viewport.scrollLeft < 0) viewport.scrollLeft += h;
      }
      function pause(ms){ pauseUntil = performance.now() + (ms || 1500); }
      function step(ts){
        var dt = ts - lastTs; lastTs = ts;
        if (dt > 100) dt = 16;
        if (!reduced && !isHovering && ts > pauseUntil && document.visibilityState !== 'hidden' && track.scrollWidth > viewport.clientWidth) {
          viewport.scrollLeft += speed * dt / 16;
          wrap();
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      viewport.addEventListener('mouseenter', function(){ isHovering = true; });
      viewport.addEventListener('mouseleave', function(){ isHovering = false; pause(400); });
      viewport.addEventListener('wheel', function(){ pause(2000); }, {passive:true});
      viewport.addEventListener('touchstart', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('touchend', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('scroll', function(){ wrap(); }, {passive:true});
      var isDown = false, startX = 0, startScroll = 0, moved = 0;
      viewport.addEventListener('mousedown', function(e){
        isDown = true; moved = 0;
        startX = e.pageX; startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        e.preventDefault();
      });
      window.addEventListener('mousemove', function(e){
        if (!isDown) return;
        var dx = e.pageX - startX;
        moved = Math.abs(dx);
        viewport.scrollLeft = startScroll - dx;
        pause(1500);
      });
      function release(){
        if (!isDown) return;
        isDown = false;
        viewport.classList.remove('is-dragging');
        pause(1200);
      }
      window.addEventListener('mouseup', release);
      window.addEventListener('mouseleave', release);
      viewport.addEventListener('click', function(e){
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0; }
      }, true);
    }
    function initAll(){ var els = document.querySelectorAll('[data-lum-carousel]'); console.log('[lum-carousel] init', els.length, 'carousels'); els.forEach(initOne); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lum-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.__lumCarouselReady) return;
    window.__lumCarouselReady = true;
    function initOne(root){
      var viewport = root.querySelector('[data-lum-viewport]');
      if (!viewport || viewport.dataset.lumInit) return;
      var track = viewport.firstElementChild; if (!track) return;
      viewport.dataset.lumInit = '1';
      var speed = parseFloat(root.dataset.scrollSpeed || '0.5');
      var lastTs = performance.now(), pauseUntil = 0, isHovering = false;
      var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      function half(){ return track.scrollWidth / 2; }
      function wrap(){ var h = half(); if (h <= 0) return; if (viewport.scrollLeft >= h) viewport.scrollLeft -= h; else if (viewport.scrollLeft < 0) viewport.scrollLeft += h; }
      function pause(ms){ pauseUntil = performance.now() + (ms || 1500); }
      function step(ts){
        var dt = ts - lastTs; lastTs = ts; if (dt > 100) dt = 16;
        if (!reduced && !isHovering && ts > pauseUntil && document.visibilityState !== 'hidden' && track.scrollWidth > viewport.clientWidth) { viewport.scrollLeft += speed * dt / 16; wrap(); }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      viewport.addEventListener('mouseenter', function(){ isHovering = true; });
      viewport.addEventListener('mouseleave', function(){ isHovering = false; pause(400); });
      viewport.addEventListener('wheel', function(){ pause(2000); }, {passive:true});
      viewport.addEventListener('touchstart', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('touchend', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('scroll', function(){ wrap(); }, {passive:true});
      var isDown=false,startX=0,startScroll=0,moved=0;
      viewport.addEventListener('mousedown', function(e){ isDown=true; moved=0; startX=e.pageX; startScroll=viewport.scrollLeft; viewport.classList.add('is-dragging'); e.preventDefault(); });
      window.addEventListener('mousemove', function(e){ if(!isDown) return; var dx=e.pageX-startX; moved=Math.abs(dx); viewport.scrollLeft=startScroll-dx; pause(1500); });
      function release(){ if(!isDown) return; isDown=false; viewport.classList.remove('is-dragging'); pause(1200); }
      window.addEventListener('mouseup', release); window.addEventListener('mouseleave', release);
      viewport.addEventListener('click', function(e){ if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved=0; } }, true);
    }
    function initAll(){ var els = document.querySelectorAll('[data-lum-carousel]'); console.log('[lum-carousel] init', els.length, 'carousels'); els.forEach(initOne); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lum-testimonial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.__lumCarouselReady) return;
    window.__lumCarouselReady = true;
    function initOne(root){
      var viewport = root.querySelector('[data-lum-viewport]');
      if (!viewport || viewport.dataset.lumInit) return;
      var track = viewport.firstElementChild;
      if (!track) return;
      viewport.dataset.lumInit = '1';
      var speed = parseFloat(root.dataset.scrollSpeed || '0.5');
      var lastTs = performance.now();
      var pauseUntil = 0;
      var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isHovering = false;
      function half(){ return track.scrollWidth / 2; }
      function wrap(){
        var h = half(); if (h <= 0) return;
        if (viewport.scrollLeft >= h) viewport.scrollLeft -= h;
        else if (viewport.scrollLeft < 0) viewport.scrollLeft += h;
      }
      function pause(ms){ pauseUntil = performance.now() + (ms || 1500); }
      function step(ts){
        var dt = ts - lastTs; lastTs = ts;
        if (dt > 100) dt = 16;
        if (!reduced && !isHovering && ts > pauseUntil && document.visibilityState !== 'hidden' && track.scrollWidth > viewport.clientWidth) {
          viewport.scrollLeft += speed * dt / 16;
          wrap();
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      viewport.addEventListener('mouseenter', function(){ isHovering = true; });
      viewport.addEventListener('mouseleave', function(){ isHovering = false; pause(400); });
      viewport.addEventListener('wheel', function(){ pause(2000); }, {passive:true});
      viewport.addEventListener('touchstart', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('touchend', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('scroll', function(){ wrap(); }, {passive:true});
      var isDown = false, startX = 0, startScroll = 0, moved = 0;
      viewport.addEventListener('mousedown', function(e){
        isDown = true; moved = 0;
        startX = e.pageX; startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        e.preventDefault();
      });
      window.addEventListener('mousemove', function(e){
        if (!isDown) return;
        var dx = e.pageX - startX;
        moved = Math.abs(dx);
        viewport.scrollLeft = startScroll - dx;
        pause(1500);
      });
      function release(){
        if (!isDown) return;
        isDown = false;
        viewport.classList.remove('is-dragging');
        pause(1200);
      }
      window.addEventListener('mouseup', release);
      window.addEventListener('mouseleave', release);
      viewport.addEventListener('click', function(e){
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0; }
      }, true);
    }
    function initAll(){ var els = document.querySelectorAll('[data-lum-carousel]'); console.log('[lum-carousel] init', els.length, 'carousels'); els.forEach(initOne); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lum-trustpilot-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.__lumCarouselReady) return;
    window.__lumCarouselReady = true;

    function initOne(root){
      var viewport = root.querySelector('[data-lum-viewport]');
      if (!viewport || viewport.dataset.lumInit) return;
      var track = viewport.firstElementChild;
      if (!track) return;
      viewport.dataset.lumInit = '1';

      var speed = parseFloat(root.dataset.scrollSpeed || '0.6');
      var lastTs = performance.now();
      var pauseUntil = 0;
      var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isHovering = false;

      function half(){ return track.scrollWidth / 2; }
      function wrap(){
        var h = half(); if (h <= 0) return;
        if (viewport.scrollLeft >= h) viewport.scrollLeft -= h;
        else if (viewport.scrollLeft < 0) viewport.scrollLeft += h;
      }
      function pause(ms){ pauseUntil = performance.now() + (ms || 1500); }

      function step(ts){
        var dt = ts - lastTs; lastTs = ts;
        if (dt > 100) dt = 16; // tab was inactive
        if (!reduced && !isHovering && ts > pauseUntil && document.visibilityState !== 'hidden' && track.scrollWidth > viewport.clientWidth) {
          viewport.scrollLeft += speed * dt / 16;
          wrap();
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);

      // Hover pause (desktop)
      viewport.addEventListener('mouseenter', function(){ isHovering = true; });
      viewport.addEventListener('mouseleave', function(){ isHovering = false; pause(400); });

      // Interaction pause
      viewport.addEventListener('wheel', function(){ pause(2000); }, {passive:true});
      viewport.addEventListener('touchstart', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('touchend', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('scroll', function(){ wrap(); }, {passive:true});

      // Mouse-drag scroll on desktop
      var isDown = false, startX = 0, startScroll = 0, moved = 0;
      viewport.addEventListener('mousedown', function(e){
        isDown = true; moved = 0;
        startX = e.pageX; startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        e.preventDefault();
      });
      window.addEventListener('mousemove', function(e){
        if (!isDown) return;
        var dx = e.pageX - startX;
        moved = Math.abs(dx);
        viewport.scrollLeft = startScroll - dx;
        pause(1500);
      });
      function release(){
        if (!isDown) return;
        isDown = false;
        viewport.classList.remove('is-dragging');
        pause(1200);
      }
      window.addEventListener('mouseup', release);
      window.addEventListener('mouseleave', release);

      // Prevent click after drag
      viewport.addEventListener('click', function(e){
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0; }
      }, true);
    }

    function initAll(){
      var els = document.querySelectorAll('[data-lum-carousel]');
      console.log('[lum-carousel] init', els.length, 'carousels');
      els.forEach(initOne);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lum-trustpilot"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.__lumCarouselReady) return;
    window.__lumCarouselReady = true;
    function initOne(root){
      var viewport = root.querySelector('[data-lum-viewport]');
      if (!viewport || viewport.dataset.lumInit) return;
      var track = viewport.firstElementChild; if (!track) return;
      viewport.dataset.lumInit = '1';
      var speed = parseFloat(root.dataset.scrollSpeed || '0.5');
      var lastTs = performance.now(), pauseUntil = 0, isHovering = false;
      var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      function half(){ return track.scrollWidth / 2; }
      function wrap(){ var h = half(); if (h <= 0) return; if (viewport.scrollLeft >= h) viewport.scrollLeft -= h; else if (viewport.scrollLeft < 0) viewport.scrollLeft += h; }
      function pause(ms){ pauseUntil = performance.now() + (ms || 1500); }
      function step(ts){
        var dt = ts - lastTs; lastTs = ts; if (dt > 100) dt = 16;
        if (!reduced && !isHovering && ts > pauseUntil && document.visibilityState !== 'hidden' && track.scrollWidth > viewport.clientWidth) { viewport.scrollLeft += speed * dt / 16; wrap(); }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      viewport.addEventListener('mouseenter', function(){ isHovering = true; });
      viewport.addEventListener('mouseleave', function(){ isHovering = false; pause(400); });
      viewport.addEventListener('wheel', function(){ pause(2000); }, {passive:true});
      viewport.addEventListener('touchstart', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('touchend', function(){ pause(2500); }, {passive:true});
      viewport.addEventListener('scroll', function(){ wrap(); }, {passive:true});
      var isDown=false,startX=0,startScroll=0,moved=0;
      viewport.addEventListener('mousedown', function(e){ isDown=true; moved=0; startX=e.pageX; startScroll=viewport.scrollLeft; viewport.classList.add('is-dragging'); e.preventDefault(); });
      window.addEventListener('mousemove', function(e){ if(!isDown) return; var dx=e.pageX-startX; moved=Math.abs(dx); viewport.scrollLeft=startScroll-dx; pause(1500); });
      function release(){ if(!isDown) return; isDown=false; viewport.classList.remove('is-dragging'); pause(1200); }
      window.addEventListener('mouseup', release); window.addEventListener('mouseleave', release);
      viewport.addEventListener('click', function(e){ if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved=0; } }, true);
    }
    function initAll(){ var els = document.querySelectorAll('[data-lum-carousel]'); console.log('[lum-carousel] init', els.length, 'carousels'); els.forEach(initOne); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
